module.exports = __webpack_public_path__ + "static/media/02-textpage.e1f28688.png";